import { EventsTable } from "fleet/view/event/table";
import PropTypes from "prop-types";
import React from "react";
import { NavLoader } from "ui/loader";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class EventV3List extends React.PureComponent {
  static get propTypes() {
    return {
      applications: PropTypes.object.isRequired,
      devices: PropTypes.object.isRequired,
      eventsV3: PropTypes.array.isRequired,
      fetchEventsV3: PropTypes.func.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      unloadEventsV3: PropTypes.func.isRequired,
    };
  }

  componentWillUnmount() {
    const { unloadEventsV3 } = this.props;
    unloadEventsV3();
  }

  _renderView() {
    const { applications, devices, eventsV3, fetchEventsV3, storesLoaded } =
      this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    return (
      <EventsTable
        events={eventsV3}
        applications={applications}
        devices={devices}
        fetchMethod={fetchEventsV3}
      />
    );
  }

  render() {
    const view = this._renderView();

    return (
      <Page title="Events">
        <Box noHeader={true}>{view}</Box>
      </Page>
    );
  }
}

export { EventV3List };
